(() => {
  const startBestSellerCarousel = () => {
    const productSection = [...document.querySelectorAll('.shopify-section')].find((section) => {
      const heading = section.querySelector('.collection__title h2, .title-wrapper-with-link h2');
      return heading?.textContent.trim().toLocaleUpperCase('fr-FR') === 'NOS MEILLEURES VENTES';
    });

    const carousel = productSection?.querySelector('slider-component');
    const slider = carousel?.querySelector('[id^="Slider-"]');
    const nextButton = carousel?.querySelector('button[name="next"]');

    if (!carousel || !slider || !nextButton || carousel.dataset.autoScroll === 'true') return;
    carousel.dataset.autoScroll = 'true';

    let timer;

    const pause = () => window.clearInterval(timer);
    const play = () => {
      pause();
      timer = window.setInterval(() => {
        // Do not move the carousel behind the header search modal. A regular
        // button.click() bubbles to <body>, where Dawn treats it as a click
        // outside the search and closes the modal.
        if (document.querySelector('.header__search details[open]')) return;

        if (nextButton.disabled) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          nextButton.dispatchEvent(
            new MouseEvent('click', {
              bubbles: false,
              cancelable: true,
              view: window,
            })
          );
        }
      }, 3000);
    };

    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', play);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', play);
    carousel.addEventListener('touchstart', pause, { passive: true });
    carousel.addEventListener('touchend', () => window.setTimeout(play, 1000), { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause();
      else play();
    });

    play();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startBestSellerCarousel, { once: true });
  } else {
    startBestSellerCarousel();
  }
})();
